import * as Yup from 'yup'

const cmsMediaCreateScheme = Yup.object().shape({
  images: Yup.array()
    .of(
      Yup.mixed()
        .test(
          [ 'content_type' ],
          'Image files only. (*.jpeg or *.png)',
          (value) => {
            if (!value) return true
            else return (value && [ 'image/png', 'image/jpeg' ].includes(value.type))
          }
        )
        .test(
          [ 'content_type' ],
          'Maximum file size is 3MB.',
          (value) => {
            if (!value) return true
            else return (value && (Math.round(value.size / 1000) < 3000))
          }
        )
    )
})

export default cmsMediaCreateScheme
